<div class="strength"> {{barLabel}}&nbsp;
  <ul class="strengthBar"  style="margin-inline-start: 21px; display: flex;">
    <li class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
  </ul>
  <br>
</div>

 <!-- <div class="strength">{{barLabel}}&nbsp;
  <ul class="strengthBar">
    <li class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
  </ul>
  <br>
  <p class="alert alert-info" *ngIf="msg">{{msg}}</p>
</div> -->
